import React from "react";
import { graphql } from "gatsby";
import { Layout, SEO } from "../components";
import { redirectToRegionPath } from "../utils/region";
import experiments from "../data/experiments.yml";
import homeJsonldSchema from "../data/home/jsonldSchema/homeJsonldSchema.yml";
import indJsonldSchema from "../data/home/jsonldSchema/indJsonldSchema.yml";
import Home from "../components/homepageV1/Home";

const Index = ({
  location,
  data: { homePageData, testimonials, personas },
}) => {
  const region = "IN";
  const displayPrimaryCTA = "/demo/?gc_source=home&ac_form_tag=AF_DEMO_HOME";
  redirectToRegionPath();
  return (
    <Layout
      region="IN"
      announcement={homePageData?.announcement}
      newFeatureMenuItemID={`home_page_feature_${region.toLowerCase()}_link`}
      displayPrimaryCTA={displayPrimaryCTA}
      displaySecondaryCTA={false}
      displayBannerLoginCTA={true}
      isHomePage={true}
    >
      <Home
        region="IN"
        location={location}
        data={{
          ...homePageData,
          ...testimonials.nodes,
          ...personas,
        }}
      />
    </Layout>
  );
};

export const HomePageData = graphql`
  query homeMetaData {
    homePageData: datoCmsHomePage(
      region: { eq: "IN" }
      originalId: { eq: "dbyE4jseRFS7TnMN3_XiCg" }
    ) {
      seo {
        title
        description
        image {
          url
        }
      }
      announcement
      heroBanners {
        id
        title
        description
        image {
          alt
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
        imageAlignment
        sortOrder
        video {
          video {
            muxPlaybackId
          }
        }
        videoId
      }
      moduleSectionHeading
      modules {
        id
        title
        advantages {
          id
          desc
          desc1
        }
        image {
          alt
          gatsbyImageData(layout: CONSTRAINED, width: 168, placeholder: BLURRED)
        }
        iconName
        video {
          video {
            muxPlaybackId
          }
        }
      }
      ecosystemSectionTitle
      ecosystemSectionImage {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 550, placeholder: BLURRED)
      }
      ecosystemSectionDescription
      ecosystems {
        ... on DatoCmsFlipCard {
          id
          displayOrder
          title
          backContent
          learnMoreUrl
          backgroundColor
          cardImages {
            gatsbyImageData(
              layout: CONSTRAINED
              width: 240
              height: 240
              placeholder: BLURRED
            )
            alt
          }
        }
      }
      personaSection {
        heading
        description
        sectionId
      }
    }

    testimonials: allDatoCmsTestimonial(
      filter: {
        isActive: { eq: true }
        showInPages: { elemMatch: { code: { eq: "HOMEPAGE" } } }
        employeeName: { eq: "Satish K" }
      }
      limit: 1
    ) {
      nodes {
        feedback
        employeeName
        employeeDesignation
        companyLogo {
          gatsbyImageData(
            layout: FIXED
            placeholder: BLURRED
            width: 40
            height: 40
          )
        }
        companyLogoAltText
        rating
        testimonialImage {
          gatsbyImageData(
            layout: FIXED
            placeholder: BLURRED
            width: 100
            height: 100
          )
        }
        testimonialImageAltText
        slug
      }
    }

    personas: allDatoCmsPersona(
      filter: { showInPages: { elemMatch: { code: { eq: "HOMEPAGE" } } } }
      sort: { displayOrder: ASC }
    ) {
      nodes {
        title
        image {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 64)
          alt
        }
        primaryCtaName
        primaryCtaUrl
        secondaryCtaName
        secondaryCtaUrl
        sections {
          heading
          description
          color
          bulletColor
          image {
            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
          }
          video {
            video {
              muxPlaybackId
            }
          }
          videoId
        }
        sectionId
      }
    }
  }
`;

export default Index;

export const Head = ({ data: { homePageData }, location: { pathname } }) => {
  const { type, name, sameAs } = homeJsonldSchema;
  const { contactPoint, url } = indJsonldSchema;
  const node = {
    type,
    name,
    contactPoint,
    sameAs,
    url,
  };

  return (
    <>
      <meta name="optimize-exp-id" content={experiments.homePage.id} />
      <SEO
        datoSeo={homePageData.seo}
        pathname={pathname}
        node={node}
        hrefLang={true}
        availableInRegions="IN, ME, ID, SG, MY"
      />
    </>
  );
};
